import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export default class Error extends React.Component {
  render () {
    return (
      <div className='error'>
        <h1>It looks like there was an error</h1>
        <p><Link to='/'>Click here</Link> to go back to the homepage</p>
      </div>
    )
  }
}

Error.defaultProps = {
  error_title: 'Unknown Error',
  error_desc: 'No more info'
}
